import { render, staticRenderFns } from "./CouchdbCredentialsModal.vue?vue&type=template&id=643630fc&"
import script from "./CouchdbCredentialsModal.vue?vue&type=script&lang=js&"
export * from "./CouchdbCredentialsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CouchdbCredentialsModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/CouchdbCredentialsModal.vue
// module id = 2345
// module chunks = 1